import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, whatsappHref } from "@/data/site";
import { FAQ } from "@/constants/testIds";
import { fadeUp, viewport } from "@/lib/motion";
import { MessageCircle } from "lucide-react";

export const Faq = () => {
  return (
    <section id="faq" className="relative bg-surface py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <motion.p
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            variants={fadeUp}
            className="font-serif-accent italic text-lg text-brand-green"
          >
            Good to know
          </motion.p>
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            variants={fadeUp}
            className="mt-3 font-heading font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl"
          >
            Frequently asked questions
          </motion.h2>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          variants={fadeUp}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={FAQ.item(i)}
                className="rounded-2xl border border-slate-200 bg-white px-6 shadow-[0_8px_30px_rgb(0,0,0,0.03)]"
              >
                <AccordionTrigger className="py-5 text-left font-heading text-base sm:text-lg font-semibold text-ink hover:no-underline hover:text-brand-blue">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          variants={fadeUp}
          className="mt-10 text-center"
        >
          <p className="text-slate-600">Still have a question?</p>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-green px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-brand-green/25 transition-all hover:bg-brand-green-dark active:scale-95"
          >
            <MessageCircle className="h-4 w-4" /> Chat with us on WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};
